import { GetterTree } from "vuex";
import { IDocumentTemplateState } from "@/store/modules/documentTemplate/state";
import DocumentTemplate from "@/types/documents/documentTemplate/DocumentTemplate";

import { IDataProvider, IRootState } from "@/store";

export enum DocumentTemplateGetters {
  GET_ALL = "GET_ALL_DOCUMENT_TEMPLATE",
  GET_CURRENT = "GET_CURRENT_DOCUMENT_TEMPLATE",
  GET_DATA_PROVIDER = "GET_DATA_PROVIDER_DOCUMENT_TEMPLATE",
}

export const getters: GetterTree<IDocumentTemplateState, IRootState> = {
  [DocumentTemplateGetters.GET_ALL](state): DocumentTemplate[] | null {
    return state.documentTemplates;
  },
  [DocumentTemplateGetters.GET_CURRENT](state): DocumentTemplate | null {
    return state.documentTemplate;
  },
  [DocumentTemplateGetters.GET_DATA_PROVIDER](
    state
  ): IDataProvider<DocumentTemplate> | null {
    return state.dataProvider;
  },
};
